module.exports = __webpack_public_path__ + "static/logo-imessage-a0108495064066c742ba2d52314b2624.png";